<template>
	<div element-loading-text="更新数据中..." v-loading.fullscreen.lock="spinning" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<WmsTable rowKey="deliveryTaskCode" v-bind="$attrs" :columns="newColumns" is-row-selection isExpanded_hidden
			@selectChange="selectChangeCall" @pageChange="pageChangeCall" :dataSource="dataSource" listener ref="wmsTable"
			:isPagination="query" :hasHeader="false" :openAll="true" :preserveSelectedRowKeys="true" @expendOpen="expendOpen">
			<template slot="FBAUpload" slot-scope="{ text, record, index }">
				<el-button :loading="refreshLoading" type="text" @click="uploadToAmz(record)"
					:disabled="record.fbaUploadCarton == 1">更新数据</el-button>
			</template>
			<template slot="platformOrderNo" slot-scope="{ text, record, index }">
				<div>
					{{ text }}
					<el-tag v-if="prentType == 'smallBag' && record.orderSource && orderSourceEnum[record.orderSource]">
						{{ orderSourceEnum[record.orderSource] }}
					</el-tag>
				</div>
			</template>
			<template slot="FBAexcal" slot-scope="{ text, record, index }">
				<FBAFun :record="record" @success="$emit('refeash')" />
			</template>
			<template slot="FBAshipping" slot-scope="{ text, record, index }">
				<div>
					<el-button type="primary" @click="downloadShipping(record)" :disabled="record.fbaUploadCarton == 0">同步并下载箱唛
					</el-button>

					<template v-if="prentType == 'FBA' && 'builtBag'.includes($attrs.tableType)">
						<el-button type="warning" style="margin-top: 8px" @click="showCheck(record.deliveryTaskCode)"
							v-if="record.fbaUploadCarton === 1">
							箱唛检查
						</el-button>
						<div style="color: crimson; font-size: 10px" v-if="record.fbaBoxMarkAbnormal == 2">
							箱唛与箱子序号对应异常
						</div>
					</template>
				</div>
			</template>
			<template slot="shipmentCodeAction" slot-scope="{ text, record, index }">
				<div @click="shipInvoiceDetails(record)" style="color: #40a9ff; cursor: pointer" class="shipmentCode__span"
					:class="{
						shipment__error: false,
					}">
					{{ text }}
					<div class="interceptIcon" v-if="record.interceptStatus == 1">拦</div>
					<div class="interceptIcon" v-if="record.crossDockingFlag == 1">
						越
					</div>
				</div>
				<el-tag type="warning" effect="dark" v-if="record.allIncludeFlag === 1">一价全包</el-tag>
				<template v-if="record.customerTagNameList?.length">
					<div class="customerTag" v-for="item in record.customerTagNameList" :key="item">
						{{ item }}
					</div>
				</template>
				<el-tag type="warning" v-if="record.overseasInvFlag === 1">海外备货</el-tag>
			</template>
			<template slot="logisticsConfig" slot-scope="{ text, record, index }">
				<el-tooltip class="item" effect="light" placement="top">
					<div slot="content" style="max-width: 200px">
						{{ record.itIntForwarderConfigIdDesc }}
					</div>
					<el-select v-model="record.itIntForwarderConfigIdDesc" placeholder="请选择" @focus="selectOnfocus(record)"
						:loading="selectLoading" filterable @change="forwarderChange($event, record, index)" :detail="record"
						style="width: 220px" :disabled="$attrs.tableType == 'shipped'">
						<el-option :label="item.forwarder + '-' + item.shippingType" :value="item.intForwarderConfigId"
							v-for="item in onSelectForwarderList" :key="item.intForwarderConfigId" style="max-width: 350px">
							<el-tooltip effect="light" placement="top" :content="item.forwarder + '-' + item.shippingType">
								<span>{{ item.forwarder + "-" + item.shippingType }}</span>
							</el-tooltip>
						</el-option>
					</el-select>
				</el-tooltip>
			</template>
			<template slot="logisticsCode" slot-scope="{ text, record, index }">
				<div>
					<div>
						<span v-for="(item, index) in record.logisticsDetailList" :key="index" v-if="item.logisticsCode">
							{{ item.logisticsCode }}
							<span v-if="item.finalLogisticsCode">({{ item.finalLogisticsCode }})</span>
						</span>
					</div>
					<div style="text-align: left" v-if="prentType == 'smallBag'">
						<a href="javascript:;" @click="createWaybillNumber(record)"
							v-if="!record.hasLogisticsCode && $attrs.tableType != 'shipped'">快速生成物流单号</a>
						<a href="javascript:;" @click="resetWaybillNumber(record)" v-else>重新生成物流单号</a>
					</div>
				</div>
			</template>
			<template slot="canDeliveryAction" slot-scope="{ text, record, index }">
				<span :style="{ color: text ? '#40a9ff' : 'orange' }">{{
					["不可发货 ", "可发货"][text]
				}}</span>
			</template>
			<template slot="warehouseAction" slot-scope="{ text, record, index }">
				<span>
					{{
						warehouses.reduce((pre, item) => {
							return item.value === text ? item.label : pre;
						}, "")
					}}
				</span>
			</template>
			<div slot="action" style="display: flex; flex-wrap: wrap" slot-scope="{ text, record, index }">
				<span class="span__btn" style="color: #40a9ff" @click="shipInvoiceDetails(record)">发货单详情</span>
				<!-- <span class="span__btn" style="color: #40a9ff" @click="remarkH(record)">备注</span> -->
				<span class="span__btn" style="color: #40a9ff" @click="remarkManager(record)" v-if="
					record.extendDTO &&
					(record.extendDTO.managerRemark ||
						record.extendDTO.managerRemarkImgs)
				">查看担当备注</span>
				<span class="span__btn" style="color: orange" @click="printDetail(record)" v-if="
					prentType == 'smallBag' &&
					'builtBag,shipped'.includes($attrs.tableType)
				">打印物流面单</span>
				<span class="span__btn" style="color: orange" @click="printDetail(record)" v-if="
					prentType == 'largeBag' &&
					'builtBag,shipped'.includes($attrs.tableType)
				">打印物流面单</span>

				<span class="span__btn" style="color: orange" @click="downocs(record)" v-if="
					(prentType == 'FBA' || prentType == 'largeBag') &&
					'builtBag,shipped'.includes($attrs.tableType) &&
					record.logisticsCompanyCode === 'OCS'
				">下载纸质面单</span>

				<span class="span__btn" style="color: #40a9ff" @click="getOperation(record)">日志</span>
				<span class="span__btn" style="color: #40a9ff" @click="downloadPacking(record)" v-if="
					($attrs.tableType === 'shipped' ||
						$attrs.tableType === 'builtBag') &&
					prentType == 'largeBag'
				">下载装箱清单</span>
				<span class="span__btn" style="color: #40a9ff" @click="downloadBoxMarkFile(record)" v-if="
					($attrs.tableType === 'shipped' ||
						$attrs.tableType === 'builtBag') &&
					prentType == 'largeBag'
				">下载箱唛</span>

				<span class="span__btn" v-if="
					$attrs.tableType === 'builtBag' &&
					(record.payStatus == 0 ||
						record.payStatus == 2 ||
						record.payStatus == 3)
				" @click="checkExpress(record)" :disabled="record.fbaDownloadBoxMark == 0 && prentType == 'FBA'"
					style="width: 60px; font-size: 14px; color: #40a9ff">确认发货</span>
				<span class="span__btn" :style="{ color: record.recharged === 1 ? 'green' : 'red' }"
					v-if="$attrs.tableType === 'builtBag' && record.payStatus == 3">{{
						record.recharged === 1
							? "客户余额足够，可操作发货"
							: "扣款成功，余额不足，无法发货"
					}}</span>
				<span class="span__btn" style="color: red"
					v-if="$attrs.tableType === 'builtBag' && record.payStatus == 1">支付中</span>
				<span class="span__btn" style="color: orange"
					v-if="$attrs.tableType === 'toBeProcessed' && prentType != 'smallBag'"
					@click="createPickTaskH(record)">生成拣货任务</span>
				<span class="span__btn" style="color: orange" v-if="$attrs.tableType === 'shipped' && prentType != 'smallBag'"
					@click="printBuildDetail(record)">下载装箱清单</span>
				<span class="span__btn" style="color: #40a9ff" @click="noDeclaratioSku(record)" v-if="
					record.declarationError &&
					(($attrs.tableType === 'toBeProcessed' &&
						prentType == 'smallBag') ||
						($attrs.tableType === 'buildingBag' && prentType != 'smallBag') ||
						$attrs.tableType === 'waitUp')
				">下载问题商品</span>
				<span class="span__btn" style="color: #40a9ff" @click="getAddition(record)">发货附加项</span>
				<span class="span__btn" style="color: #40a9ff" @click="toDownloadPackingDetailsFile(record)"
					v-if="$attrs.tableType === 'builtBag' && prentType == 'largeBag' && record.thirdWarehouseType == 4">打印纳品书</span>
				<span class="span__btn" style="color: #40a9ff" @click="toAbandonDeliveryTask(record, 1)"
					v-if="$attrs.tableType === 'builtBag'">废弃</span>
				<span class="span__btn" style="color: #40a9ff" @click="toAbandonDeliveryTask(record, 0)"
					v-if="$attrs.tableType === 'abandoned'">恢复</span>
				<span class="span__btn" style="color: #40a9ff" @click="finishPack(record)"
					v-if="$attrs.tableType === 'picking' && prentType === 'largeBag'">拣货完成</span>
				<span class="span__btn" style="color: #40a9ff" @click="downFile(record)"
					v-if="$attrs.tableType === 'picking' && prentType === 'largeBag'">下载拣货单</span>
        <span class="span__btn" style="color: #40a9ff" @click="removeIntercept(record)"
          v-if="['picking', 'buildingBag', 'builtBag'].includes($attrs.tableType) && record.interceptStatus == 1 && prentType === 'smallBag'">移入已拦截</span>
				<!-- <span class="span__btn" style="color: #40a9ff" @click="printBoxCode(record)"
          v-if="['largeBag','smallBag'].includes(prentType) && ['builtBag', 'shipped'].includes($attrs.tableType)">打印箱唛</span> -->
			</div>
			<template slot="expandedRender" slot-scope="{ record, son_width, targetLeft }">
				<a-table bordered :columns="realColumnsSon" :pagination="false" rowKey="deliveryTaskDetailId"
					:dataSource="record.taskDetailList" :scroll="{ x: '1200px' }" class="son__table--customize">
					<ImgView slot="productImgAction" slot-scope="text, record, index" :src="text" width="40" height="40" />
					<div slot="deductionNums" slot-scope="text, record, index">
						<el-tooltip v-if="record.pkgCodeList.length">
							<template #content>
								<div @click="showDeductionLIstanbul(record)" style="color: #fff; cursor: pointer"
									v-for="item in record.pkgCodeList" :key="item">
									{{ item }}
								</div>
							</template>
							<div class="show-two-line">
								<span @click="showDeductionLIstanbul(record)" style="color: #40a9ff; cursor: pointer">
									{{ record.pkgCodeList?.join(",") }}
								</span>
							</div>
						</el-tooltip>
						<span v-else @click="showDeductionLIstanbul(record)" style="color: #40a9ff; cursor: pointer">
							{{
								text == 0
									? "未上架"
									: text == record.deliveryNums
										? "已上架"
										: "部分上架"
							}}
						</span>
					</div>
					<div slot="pkgCodeList" slot-scope="text, record, index">
						<h6 v-for="item in text" :key="item">{{ item }}</h6>
					</div>
					<div slot="shopProductSku" slot-scope="text, record, index" style="display: flex; flex-direction: column">
						<span class="span__btn" style="color: #40a9ff" @click="goodsDetails(record)">
							{{ text }}
						</span>
						<a v-if="record?.productCode" style="margin-left: 5px" target="_blank"
							:href="`https://s.theckb.com/ja/goods/${record?.productCode}`">
							CKB链接
						</a>
					</div>
					<div slot="action" slot-scope="text, record, index">
						<span class="span__btn" style="color: #40a9ff" @click="goodsDetails(record)">
							商品详情
						</span>
						<span class="span__btn" style="color: #40a9ff" @click="remarkH(record)">
							备注
						</span>
						<span class="span__btn" style="color: #40a9ff" @click="downloadSKU(record)" v-if="prentType == 'largeBag'">
							下载SKU条形码
						</span>
					</div>
				</a-table>
			</template>
			<template slot="managerName" slot-scope="{ text, record }">
				<div>营销经理： {{ record.marketingManagerName }}</div>
				<div>复购单经理： {{ text }}</div>
			</template>
		</WmsTable>
		<el-dialog title="备注" :visible.sync="remarkInfo.visible" width="30%">
			<el-input maxlength="450" type="textarea" :rows="4" placeholder="请输入内容" v-model="remarkInfo.record.remark">
			</el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remarkBoxClose">取 消</el-button>
				<el-button type="primary" @click="remarkConfirm">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="担当备注" :visible.sync="remarkManagerInfo.visible" width="30%">
			<!-- <el-input maxlength='450' type="textarea" :rows="4" placeholder="请输入内容" v-model="remarkManagerInfo.record.managerRemark" :disabled="true">
      </el-input> -->
			<div v-if="remarkManagerInfo.record.managerRemark" style="text-align: left">
				{{ remarkManagerInfo.record.managerRemark }}
			</div>
			<div v-if="remarkManagerInfo.record.managerRemarkImgs" class="imgBox">
				<ImgView v-for="(i, index) in remarkManagerInfo.record.managerRemarkImgs" :src="i" :key="index"></ImgView>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="remarkBoxClose">取 消</el-button>
        <el-button type="primary" @click="remarkConfirm">确 定</el-button> -->
			</span>
		</el-dialog>
		<el-dialog title="未上架商品" :visible.sync="pagePickingTaskNo.visible" append-to-body>
			<el-table :data="pagePickingTaskNo.list" :border="true" height="600">
				<el-table-column prop="productImg" label="商品图片">
					<template slot-scope="record">
						<ImgView :src="record.row.productImg"></ImgView>
					</template>
				</el-table-column>
				<el-table-column prop="pkgCode" label="批次号">
					<template slot-scope="record">
						<p v-for="item in record.row.pkgCodes" :key="item">{{ item }}</p>
					</template>
				</el-table-column>
				<el-table-column prop="shopProductSku" label="商品SKU"></el-table-column>
				<el-table-column prop="productSku" label="平台SKU"></el-table-column>
			</el-table>
			<el-pagination @size-change="packHandleSizeChange" @current-change="packHandleCurrentChange"
				:current-page.sync="pagePickingTaskNo.current" :page-size="pagePickingTaskNo.pageSize"
				:page-sizes="[10, 20, 40]" layout="total, sizes, prev, pager, next" :total="pagePickingTaskNo.total" background
				style="margin-top: 20px; text-align: right">
			</el-pagination>
		</el-dialog>
		<el-dialog title="日志" :visible.sync="deliveryOperation.visible">
			<h2 style="text-align: left">
				国际发货单号: {{ deliveryOperation.deliveryTaskCode }}
			</h2>
			<WmsTable :hasHeader="false" :columns="operationCol" :dataSource="deliveryOperation.list" :isPagination="false"
				:scrollY="500"></WmsTable>
		</el-dialog>
		<el-dialog title="发货附加项" :visible.sync="additionVisible">
			<WmsTable :hasHeader="false" :columns="additionCol" :dataSource="additionDataSource" :isPagination="false"
				:scrollY="500">
				<ImgView slot="image" slot-scope="{ text, record, index }" :src="text" width="40" height="40" v-if="text" />
			</WmsTable>
		</el-dialog>
		<el-dialog title="抵扣信息" :visible.sync="deductionVisible" width="1000px">
			<div style="text-align: left; font-size: 20px" v-if="deductionVisible">
				<span style="margin-right: 20px">发货单数量： {{ deductionData.data?.deliveryNums }} </span><span
					style="margin-right: 20px">已抵扣数量： {{ deductionData.data?.deductionNums }} </span><span>未抵扣数量：
					{{
						deductionData.data?.deliveryNums - deductionData.data?.deductionNums
					}}
				</span>
			</div>
			<WmsTable :hasHeader="false" :columns="deductionColumns" :dataSource="deductionData.list" :isPagination="false"
				:scroll="{ x: 800, y: 500 }">
			</WmsTable>
		</el-dialog>
		<CheckBoxs ref="CheckBoxsRef" @close="closeCheckBoxs" />
	</div>
</template>


<script>
import axios from "axios";
import { baseURL } from "@/const/env";
import { Loading } from "element-ui";
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import CheckBoxs from "./FBAFun/CheckBoxs.vue";
import FBAFun from "@/views/outOfStock/internationalShipment/components/FBAFun";
import { Table } from "ant-design-vue";
import {
	columns,
	columns_small,
	columns_FBA_builtBag,
	columnsSon,
	columnsSon_waitUp,
	columns_largeBag,
	columns_FBA_shipped,
	operationCol,
	additionCol,
	deductionColumns,
} from "@/views/outOfStock/internationalShipment/components/InterListData";
import store from "@/store";
import {
	createPickTask,
	confirmDelivery,
	boxMarkLink,
	changeLogistics,
	getChannel,
	changeChannel,
	getLogisticsNo,
	taskRemark,
	skuRemark,
	uploadDataToAmazon,
	downloadPackingList,
	modifyForwarder,
	b2bExportDeliveryTask,
	downloadCustomerBoxMarkFile,
	downloadCustomerPackingListFile,
	pagePickingTaskNotListed,
	listDeliveryTaskOperation,
	getAgainLogisticsNo,
	taskGetForwarder,
	noDeclaratioSkuExport,
	getAdditionalDetails,
	deliverySkuDeductionRecord,
	deliveryTaskInfo,
	downloadPackingDetailsFile,
	abandonDeliveryTask,
	downloadOcsLabel,
	updateStatusApi,
	pickFinishApi,
	downloadPickTaskApi,
	getOverseasBoxCodeApi,
  removeInterceptApi
} from "@/apis/outStock";
import { customerTagMap } from "@/types/customer";
import { templatePrintByGridcode } from "@/utils/print";
export default {
	name: "InterList",
	components: {
		[Table.name]: Table,
		WmsTable,
		ImgView,
		FBAFun,
		CheckBoxs,
	},
	props: {
		singleProduct: {
			type: Number | undefined,
			required: true,
		},
		prentType: {
			type: String,
		},
		layout: {
			type: String,
			default: () => {
				return "";
			},
		},
		total: {
			type: String | Number,
		},
		dataSource: {
			type: Array,
			default: (_) => {
				return [];
			},
		},
		forwarder: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			spinning: false,
			tableKey: null,
			columns,
			columnsSon,
			columnsSon_waitUp,
			columns_small,
			columns_largeBag,
			operationCol,
			additionCol,
			deductionColumns,
			carrierWayList: [],
			selRow: [],
			targetLeft: 0,
			remarkInfo: {
				visible: false,
				record: {
					remark: "",
				},
			},
			orderSourceEnum: {
				1: "直行便",
				2: "base",
				3: "shopify",
				4: "stores",
				7: "自建独立站",
				11: "Tiktok"
			},
			remarkManagerInfo: {
				visible: false,
				record: {
					managerRemark: "",
					managerRemarkImgs: [],
				},
			},
			query: {
				current: 1,
				pageSize: 20,
				total: 0,
			},
			pagePickingTaskNo: {
				list: [],
				current: 1,
				total: 0,
				pageSize: 20,
				visible: false,
				saveParams: {},
			},
			links: [],
			deliveryOperation: {
				visible: false,
				deliveryTaskCode: "",
				list: [],
			},
			onSelectForwarderList: [],
			selectLoading: false,
			refreshLoading: false,
			additionDataSource: [],
			additionVisible: false,
			deductionVisible: false,
			deductionData: {
				list: [],
				data: {
					deliveryNums: 0,
					deductionNums: 0,
				},
			},
			customerTagMap,
		};
	},
	watch: {
		total: {
			immediate: true,
			handler: function (newVal, oldVal) {
				this.query.total = newVal;
			},
			immediate: true,
			keep: true,
		},
		//国际发货单居然 没有ID
		dataSource: {
			immediate: true,
			handler: function (newVal, oldVal) {
				newVal.forEach((item) => {
					item.id = item.deliveryTaskId;
					item.wmsIntForwarderConfigId = this.matchForwarder(item);
					item.oldWmsIntForwarderConfigId = item.wmsIntForwarderConfigId;
					item.itIntForwarderConfigIdDesc = `${item.wmsForwarder}-${item.wmsShippingType}`;
				});
				if (newVal.length == 1) {
					setTimeout(() => {
						this.$refs.wmsTable.openAllExpend();
					}, 1);
					const that = this;
					this.$nextTick(() => {
						that.expendOpen({ deliveryTaskCode: newVal[0].deliveryTaskCode });
					});
				}
			},
			immediate: true,
			keep: true,
		},
	},
	computed: {
		logisticsCompany: function () {
			return this.$store.getters.getLogisticsCompany;
		},
		warehouses: function () {
			return store.getters.getWarehouses;
		},
		newColumns: function () {
			let _columns = [...columns];
			if (this.prentType === "FBA") {
				_columns.splice(1, 1);
				_columns = _columns.filter(item => item.dataIndex != 'rtsSlaTimeDate')
			}
			if (
				(this.$attrs.tableType === "builtBag" ||
					this.$attrs.tableType === "abandoned") &&
				this.prentType === "FBA"
			) {
				_columns = [...columns_FBA_builtBag];
			}
			if (this.$attrs.tableType === "shipped" && this.prentType === "FBA") {
				_columns = [...columns_FBA_shipped];
			}
			if (
				this.prentType === "smallBag" &&
				this.$attrs.tableType === "buildingBag"
			) {
				let index = [...columns_small].findIndex((v) => v.title == "店铺名称");
				let arr = [...columns_small];
				arr.splice(index + 1, 0, {
					title: "异常存放位置",
					key: "exceptionLocation",
					dataIndex: "exceptionLocation",
					width: 120,
				});
				_columns = arr;
			}
			if (this.prentType === "largeBag") {
				_columns = [...columns_largeBag];
			}
			if (
				this.$attrs.tableType === "shipped" ||
				this.$attrs.tableType === "builtBag" ||
				this.$attrs.tableType === "abandoned"
			) {
				let _index = _columns.findIndex((item) => item.title == "发货时间");
				_columns.splice(_index, 0, {
					title: "打包时间",
					key: "packTime",
					dataIndex: "packTime",
					rowKey: "key",
					customRender: (text, record, index) => {
						return text || "-";
					},
					width: 200,
				});
			}
			if (this.$attrs.tableType === "waitUp") {
				_columns = _columns.filter(
					(v) => v.key != "logisticsConfig" && v.key != "logisticsCode"
				);
			}
			// 在操作前面加上拦截时长和欠费时长
			let _index = _columns.findIndex((item) => item.title == "操作");
			_columns.splice(
				_index,
				0,
				{
					title: "拦截时长",
					key: "interceptionDuration",
					dataIndex: "interceptionDuration",
					rowKey: "key",
					customRender: (text, record, index) => {
						return text || "-";
					},
					width: 200,
				},
				{
					title: "欠费时长",
					key: "arrearsDuration",
					dataIndex: "arrearsDuration",
					rowKey: "key",
					customRender: (text, record, index) => {
						return text || "-";
					},
					width: 200,
				}
			);
			return _columns;
		},
		realColumnsSon: function () {
			return columnsSon_waitUp;
			// if (this.$attrs.tableType === "waitUp") {
			//   return columnsSon_waitUp
			// }
			// return columnsSon
		},
	},
	methods: {
		closeCheckBoxs() {
			this.$emit("refeash");
		},
		showCheck(code) {
			this.$refs.CheckBoxsRef.show(code);
		},
		async downocs(row) {
			// const deliveryTaskCodeList = this.selectedRows.map(i => i.deliveryTaskCode)
			const res = await downloadOcsLabel([row.deliveryTaskCode]);
			if (res.code == 0) {
				window.open(res.data);
			}
		},
		getPkgCodeList(record) {
			console.log(88888, record.pkgCodeList);
			return "-";
		},
		setUseable(Str) {
			return !this.layout.includes(Str);
		},
		matchForwarder(data) {
			let has = this.forwarder.some((item) => {
				if (item.intForwarderConfigId == data.wmsIntForwarderConfigId) {
					return true;
				}
			});
			has = has
				? data.wmsIntForwarderConfigId
				: data.wmsForwarder + "-" + data.wmsShippingType;
			return has;
		},
		pageChangeCall: function (payload) {
			this.query.current = payload.current;
			this.query.pageSize = payload.pageSize;
			this.$emit("pageChange", payload);
		},
		selectChangeCall: function (rows) {
			this.selRow = rows;
			console.log("interlist", this.selRow);
			this.$emit("selectChange", rows);
		},
		/**发货单详情**/
		shipInvoiceDetails: function (record) {
			deliveryTaskInfo({ deliveryTaskCode: record.deliveryTaskCode }).then(
				(res) => {
					if (res.success) {
						this.$router.push({
							name: "shipInvoiceDetails",
							params: {
								shipInvoiceId: record.id,
								info: res.data,
								prentType: this.prentType,
							},
						});
					}
				}
			);
		},
		/**商品详情**/
		goodsDetails: function (record) {
			console.log(record);
			deliveryTaskInfo({ deliveryTaskCode: record.deliveryTaskCode }).then(
				(res) => {
					if (res.success) {
						let info = res.data.taskDetailList.filter(
							(i) => i.deliveryTaskDetailId == record.deliveryTaskDetailId
						)[0];
						this.$router.push({
							name: "goodsDetails",
							params: {
								goodsId: record.id,
								productDetail: { ...info },
								prentType: this.prentType,
								tableType: this.$attrs.tableType,
							},
						});
					}
				}
			);
		},
		/**创建拣货任务**/
		async createPickTaskH(r) {
			let _pickType = null; // 拣货类型(0:大件 1:小件单品 2:小件多品)
			if (this.prentType == "largeBag") {
				_pickType = 0;
			} else if (this.prentType == "FBA") {
				_pickType = 3;
			} else {
				_pickType = [2, 1][r.singleProduct];
			}
			let params = {
				deliveryTaskCodes: [r.deliveryTaskCode],
				shopProductSkus: r.taskDetailList.map((item) => {
					return item.shopProductSku;
				}),
				pickType: _pickType,
				current: this.pagePickingTaskNo.current,
				pageSize: this.pagePickingTaskNo.pageSize,
			};
			let checkStatus = await pagePickingTaskNotListed(params);
			if (checkStatus.data) {
				const { records = [], total = 0 } = checkStatus.data;
				this.pagePickingTaskNo.list = records;
				this.pagePickingTaskNo.total = total;
				this.pagePickingTaskNo.saveParams = params;
				this.pagePickingTaskNo.visible = true;
				return;
			}
			createPickTask({
				deliveryTaskCodeList: [r.deliveryTaskCode],
				pickType: _pickType, // 拣货类型(0:大件 1:小件单品 2:小件多品)
			}).then(({ code, data }) => {
				if (code === 0) {
					this.$message.success("成功");
					this.$emit("refeash");
				}
			});
		},
		/**备注相关**/
		remarkH: function (r) {
			this.remarkInfo = {
				visible: true,
				record: r,
			};
		},
		// 关闭备注
		remarkBoxClose: function () {
			this.remarkInfo = {
				visible: false,
				record: {
					remark: "",
				},
			};
		},
		// 添加备注
		remarkConfirm: function () {
			// TODO 区分发货任务备注 和 单个商品的备注区别
			// this.$message.warning("开发中");
			if (this.remarkInfo.record.shopProductSku) {
				let params = {
					deliveryTaskDetailId: this.remarkInfo.record.deliveryTaskDetailId,
					remark: this.remarkInfo.record.remark,
				};
				skuRemark(params).then(({ code }) => {
					if (code == 0) {
						this.$message.success("成功");
						this.remarkBoxClose();
						this.$emit("refeash");
					}
				});
			} else {
				let params = {
					deliveryTaskCode: this.remarkInfo.record.deliveryTaskCode,
					remark: this.remarkInfo.record.remark,
				};
				taskRemark(params).then(({ code }) => {
					if (code == 0) {
						this.$message.success("成功");
						this.remarkBoxClose();
						this.$emit("refeash");
					}
				});
			}
		},
		//担当备注
		remarkManager(record) {
			this.remarkManagerInfo = {
				visible: true,
				record: {
					...record.extendDTO,
					managerRemarkImgs: record.extendDTO.managerRemarkImgs
						? record.extendDTO.managerRemarkImgs.split(",")
						: "",
				},
			};
		},
		/**打印**/
		printDetail: function (record) {
			let printUrl = [];
			record.logisticsDetailList.forEach((item) => {
				if (item.logisticsTagUrl) {
					printUrl.push(item.logisticsTagUrl);

					// let comp = pdf.createLoadingTask({
					//   url: item.logisticsTagUrl, // url:"",
					//   cMapPacked: true,
					//   CMapReaderFactory
					// })
					// printUrl.push(comp)
				}
			});
			if (printUrl.length > 0) {
				// let loadingInstance = Loading.service({ text: '加载中' });
				// this.links = printUrl
				// this.$refs.printPdf.print()
				printUrl.forEach((item) => {
					let isPDF = item.slice(-1, -3).indexOf("PDF");
					console.log(isPDF);
					window.open(
						item + (isPDF != -1 ? "?response-content-type=application/pdf" : "")
					);
				});
			} else {
				this.$message.warning("请线下打印面单");
			}
		},

		pdfLoaded() {
			let loadingInstance = Loading.service({ text: "加载中" });
			this.$refs.printPdf.print();
			loadingInstance.close();
		},
		/**打印装箱清单**/
		printBuildDetail: function (record) {
			let params = {
				deliveryTaskCodeList: [record.deliveryTaskCode],
			};
			downloadPackingList(params).then((res) => {
				let blobObj = new Blob([res.data], {
					type: "application/octet-stream",
				});
				let blobUrl = window.URL.createObjectURL(blobObj);
				const link = document.createElement("a");
				link.href = blobUrl;
				link.download = record.deliveryTaskCode + "装箱清单.xls";
				link.click();
				window.URL.revokeObjectURL(link.href);
				if (code == 0) {
					this.$message.success("操作成功");
				}
			});
		},
		createWaybillNumber: function (record, index) {
			if (this.$attrs.tableType == "shipped") {
				this.$confirm(`是否快速生成运单号`, "提示", {
					confirmButtonText: "确认",
					type: "error",
					cancelButtonText: "取消",
				}).then(() => {
					let params = {
						deliveryTaskCode: record.deliveryTaskCode,
					};
					getLogisticsNo(params).then(({ code }) => {
						if (code == 0) {
							this.$message.success("操作成功");
							this.$emit("refeash");
						}
					});
				});
			} else {
				let params = {
					deliveryTaskCode: record.deliveryTaskCode,
				};
				getLogisticsNo(params).then(({ code }) => {
					if (code == 0) {
						this.$message.success("操作成功");
						this.$emit("refeash");
					}
				});
			}
		},
		resetWaybillNumber(record) {
			if (this.$attrs.tableType == "shipped") {
				this.$confirm(`是否重新生成运单号`, "提示", {
					confirmButtonText: "确认",
					type: "error",
					cancelButtonText: "取消",
				}).then(() => {
					getAgainLogisticsNo({
						deliveryTaskCode: record.deliveryTaskCode,
					}).then(({ code }) => {
						if (code == 0) {
							this.$message.success("操作成功");
							this.$emit("refeash");
						}
					});
				});
			} else {
				getAgainLogisticsNo({ deliveryTaskCode: record.deliveryTaskCode }).then(
					({ code }) => {
						if (code == 0) {
							this.$message.success("操作成功");
							this.$emit("refeash");
						}
					}
				);
			}
		},
		//确认发货
		checkExpress(record) {
			if (record.interceptStatus == 1) {
				this.$confirm(
					'<div style="color:red">该发货单已被拦截，请单独放置</div>',
					"拦截提示",
					{
						showCancelButton: false,
						dangerouslyUseHTMLString: true,
					}
				);
				return false;
			}
			this.$confirm(
				record.fbaBoxMarkAbnormal == 2
					? `<div>
        <div>是否确认发货</div>
        <div style="color:red">箱唛检查有异常，请仔细核对箱子与箱唛序号是否一致</div>
        </div>`
					: "是否确认发货",
				"提示",
				{
					showCancelButton: false,
					dangerouslyUseHTMLString: true,
				}
			).then(() => {
				confirmDelivery({
					deliveryTaskCode: record.deliveryTaskCode,
				}).then((res) => {
					if (res.code == 0) {
						this.$message.success("操作成功！");
						this.$emit("refeash");
					}
				});
			});
		},
		//货代公司change回调
		forwarderChange(val, record, index) {
			let params = {
				deliveryTaskCode: record.deliveryTaskCode,
				wmsIntForwarderConfigId: val,
			};
			modifyForwarder(params)
				.then(({ code, data }) => {
					if (code === 0) {
						if (data.needNotice) {
							this.$message.success(data.message);
						} else {
							this.$message.success("成功");
						}
					}
				})
				.finally(() => {
					this.$emit("refeash");
				});
		},
		downloadShipping(record) {
			let params = {
				deliveryTaskCode: record.deliveryTaskCode,
			};
			boxMarkLink(params).then(({ code, data }) => {
				if (code == 0) {
					this.$message.success("同步成功");
					this.$emit("refeash");
					window.open(data);
				}
			});
		},
		uploadToAmz(record) {
			let params = {
				deliveryTaskCode: record.deliveryTaskCode,
			};
			const loading = {
				num: 0,
				data: null,
				open: function () {
					this.num += 1;
					if (!this.data) {
						this.data = Loading.service({
							lock: true,
							text: "Loading",
							background: "rgba(0, 0, 0, 0.7)",
						});
					}
				},
				close: function () {
					this.num -= 1;
					if (this.num <= 0) {
						this.data.close();
						this.data = null;
					}
				},
			};
			const service = axios.create({
				// baseURL: that.domain[baseUrl], // auto
				baseURL: baseURL(), // test
				timeout: 180000, // 请求超时时间
			});
			loading.open();

			service
				.post("/wms/delivery/task/uploadDataToAmazon", params, {
					headers: {
						"Content-Type": "application/json",
						"X-AuthToken": store.getters.getToken,
					},
				})
				.then((response) => {
					if (response.data.code) {
						if (parseInt(response.data.code) !== 0) {
							this.$message.error(response.data.msg);
							loading.close();
							this.spinning = false;
						} else {
							try {
								const interverFn = async () => {
									const res = await updateStatusApi(params);
									if (res.code == 0) {
										if (res.data.status == 0) {
											setTimeout(interverFn, 3000);
										} else if (res.data.status == 2) {
											loading.close();
											this.$message.error(res.data.msg);
											this.spinning = false;
										} else if (res.data.status == 1) {
											loading.close();
											this.$message.success("同步成功");
											this.spinning = false;
											this.$emit("refeash");
										}
									}
								};

								this.spinning = true;
								interverFn();
							} catch (error) {
								this.refreshLoading = false;
								loading.close();
								this.spinning = false;
							}
						}
					}
				})
				.catch((err) => {
					loading.close();
				});
		},
		resetPage() {
			this.query.current = 1;
			this.$refs.wmsTable.resetSel();
		},
		scrollCall(res) {
			this.targetLeft = res.target.scrollLeft;
		},
		downloadSKU(record) {
			if (record.barCodeUrl) {
				let isPDF = record.barCodeUrl.slice(-1, -3).indexOf("PDF");
				console.log(isPDF);
				window.open(
					record.barCodeUrl +
					(isPDF != -1 ? "?response-content-type=application/pdf" : "")
				);
			} else {
				this.$message.warning("无SKU文件");
			}
		},
		downloadBoxMarkFile(record) {
			let params = {
				deliveryTaskCode: record.deliveryTaskCode,
			};
			downloadCustomerBoxMarkFile(params).then(({ code, data }) => {
				if (code == 0) {
					if (data) {
						window.open(data);
					} else {
						this.$message.warning("发货单无文件，请联系业务让客户上传箱唛文件");
					}
				}
			});
		},
		downloadPacking(record) {
			let params = {
				deliveryTaskCode: record.deliveryTaskCode,
			};
			downloadCustomerPackingListFile(params).then(({ code, data }) => {
				if (code == 0) {
					if (data) {
						window.open(data);
					} else {
						this.$message.warning(
							"发货单无文件，请联系业务让客户上传装箱清单文件"
						);
					}
				}
			});
		},
		packHandleCurrentChange(e) {
			console.log(e);
			this.pagePickingTaskNo.current = e;
			this.getpagePickingTaskNoList();
		},
		packHandleSizeChange(e) {
			this.pagePickingTaskNo.pageSize = e;
			this.getpagePickingTaskNoList();
		},
		getpagePickingTaskNoList() {
			pagePickingTaskNotListed({
				...this.pagePickingTaskNo.saveParams,
				current: this.pagePickingTaskNo.current,
				pageSize: this.pagePickingTaskNo.pageSize,
			}).then((res) => {
				this.pagePickingTaskNo.list = res.data.records;
			});
		},
		getOperation(record) {
			listDeliveryTaskOperation({
				deliveryTaskCode: record.deliveryTaskCode,
			}).then((res) => {
				this.deliveryOperation = {
					visible: true,
					list: res.data,
					deliveryTaskCode: record.deliveryTaskCode,
				};
			});
		},

		selectOnfocus(r) {
			this.selectLoading = true;
			this.onSelectForwarderList = [];
			taskGetForwarder({ deliveryTaskCode: r.deliveryTaskCode }).then(
				({ code, data }) => {
					if (code == 0) {
						this.onSelectForwarderList = data;
						this.selectLoading = false;
					}
				}
			);
		},
		noDeclaratioSku(record) {
			noDeclaratioSkuExport([record.deliveryTaskCode]).then((res) => {
				if (res.status == 200) {
					let blobObj = new Blob([res.data], {
						type: "application/octet-stream",
					});
					let blobUrl = window.URL.createObjectURL(blobObj);
					const link = document.createElement("a");
					link.href = blobUrl;
					link.download = `${record.deliveryTaskCode}-问题商品.xls`;
					link.click();
					window.URL.revokeObjectURL(link.href);
				}
			});
		},
		getAddition(r) {
			getAdditionalDetails({
				deliveryTaskCode: r.deliveryTaskCode,
			}).then((res) => {
				this.additionVisible = true;
				this.additionDataSource = res.data || [];
			});
		},
		showDeductionLIstanbul(r) {
			deliverySkuDeductionRecord({
				deliveryTaskDetailId: r.deliveryTaskDetailId,
			}).then((res) => {
				this.deductionData = {
					list: res.data,
					data: r,
				};
				this.deductionVisible = true;
			});
		},
		expendOpen(r) {
			deliveryTaskInfo({ deliveryTaskCode: r.deliveryTaskCode }).then((res) => {
				if (res.success) {
					let index = this.dataSource.findIndex(
						(item) => item.deliveryTaskCode == r.deliveryTaskCode
					);
					this.$refs.wmsTable.changeDataSourceData(
						index,
						"taskDetailList",
						res.data.taskDetailList
					);
				}
			});
		},
		toDownloadPackingDetailsFile(r) {
			downloadPackingDetailsFile({
				deliveryTaskCode: r.deliveryTaskCode,
			}).then((res) => {
				const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
				// const fileName = props.rowItemDetail.billNo + ' ' + dayjs().format('YYYY-MM-DD')
				const fileName = r.deliveryTaskCode + "纳品书";
				const objectUrl = URL.createObjectURL(blob);
				const a = document.createElement("a");
				document.body.appendChild(a);
				a.setAttribute("style", "display:none");
				a.setAttribute("href", objectUrl);
				a.setAttribute("download", fileName);
				a.click();
				URL.revokeObjectURL(objectUrl);
			});
		},
		toAbandonDeliveryTask(record, abandonFlag) {
			abandonDeliveryTask({
				deliveryTaskCode: record.deliveryTaskCode,
				abandonFlag,
			}).then((res) => {
				console.log(res);
				if (res.code == 0) {
					this.$message.success("成功");
					this.$emit("refeash");
				}
			});
		},
		finishPack(record) {
			this.$confirm("是否拣货完成", "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
			}).then(() => {
				pickFinishApi({
					deliveryTaskCode: record.deliveryTaskCode,
				}).then((res) => {
					console.log(res, "sss");
					if (res.success) {
						this.$message.success("拣货完成");
						this.$emit("refeash");
					}
				});
			});
		},
		downFile(record) {
			downloadPickTaskApi({
				deliveryTaskCode: record.deliveryTaskCode,
			}).then((res) => {
				const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
				// const fileName = props.rowItemDetail.billNo + ' ' + dayjs().format('YYYY-MM-DD')
				const fileName = record.deliveryTaskCode + "拣货单";
				const objectUrl = URL.createObjectURL(blob);
				const a = document.createElement("a");
				document.body.appendChild(a);
				a.setAttribute("style", "display:none");
				a.setAttribute("href", objectUrl);
				a.setAttribute("download", fileName);
				a.click();
				URL.revokeObjectURL(objectUrl);
			});
		},
		printBoxCode(record) {
			console.log(record);
			getOverseasBoxCodeApi({
				deliveryTaskCode: record.deliveryTaskCode,
			}).then((res) => {
				const codes = res.data.filter((v) => v);
				console.log(codes);
				if (codes.length) {
					templatePrintByGridcode(
						codes.map((v) => ({ gridCode: v })),
						"4"
					);
				} else {
					this.$message.warning("没有可打印的箱唛");
				}
			});
		},
    removeIntercept(record) {
      const _this = this
      this.$confirm('是否移入已拦截', "提示", {
        confirmButtonText: "确认",
        type: "warning",
        cancelButtonText: "取消",
      }).then(() => {
        removeInterceptApi({
          deliveryTaskCode: record.deliveryTaskCode
        }).then((res) => {
          if (!res.success) return
          _this.$message.success('操作成功')
          _this.$emit("refeash");
        })
      });
    }
	},
};
</script>

<style scoped>
.ant-table-expanded-row .son__table--customize>>>td,
.son__table--customize>>>th {
	border-right: 0px solid #e8e8e8 !important;
}

.shipmentCode__span {
	position: relative;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	line-height: 24px;
}

.shipment__error::before {
	position: absolute;
	bottom: 0;
	left: 0;
	content: "运单号获取异常";
	display: block;
	height: 24px;
	line-height: 24px;
	font-size: 12px;
	color: red;
}

.span__btn {
	cursor: pointer;
	padding: 1px 0;
	margin: 2px;
}

.imgBox {
	display: flex;
}

.customerTag {
	min-height: 24px;
	min-width: 24px;
	padding: 0 2px;
	border-radius: 4px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: white;
	background-color: red;
	line-height: 24px;
	font-size: 12px;
	padding: 0 8px;
	margin-left: 4px;
}

.show-two-line {
	display: -webkit-box;
	overflow: hidden;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
}
</style>
<style>
.interceptIcon {
	border: 1px solid red;
	border-radius: 50%;
	color: red;
	font-size: 12px;
	height: 18px;
	width: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	margin-left: 4px;
}
</style>
